import { render, staticRenderFns } from "./HospitalInfo.vue?vue&type=template&id=e1f2c2ec&scoped=true"
import script from "./HospitalInfo.vue?vue&type=script&lang=js"
export * from "./HospitalInfo.vue?vue&type=script&lang=js"
import style0 from "./HospitalInfo.vue?vue&type=style&index=0&id=e1f2c2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f2c2ec",
  null
  
)

export default component.exports